import { BasePublicEndpoints } from './base';
import { ResGetInvitation, ResPostUsers } from '../types/api-types';

export class Signups extends BasePublicEndpoints {
  async add(body: object) {
    return await this.requestWithStatus<ResPostUsers>('POST', '/users', body);
  }

  async getPendingByCode(code: string) {
    return await this.requestWithStatus<ResGetInvitation>(
      'GET',
      `/invitation/${encodeURIComponent(code)}`
    );
  }
}
